import { organisationIndexQueryOptions, type OrganisationIndexResponse } from '@jobilla/nexus-sdk'
import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'
import { AxiosError } from 'axios'

export const organisationGuard = async (
	queryClient: QueryClient,
	params: { companyId: string },
): Promise<{ jobillaOrgId: string; workosOrgId: string | null; isDemo: boolean }> => {
	const findMatch = (orgs: OrganisationIndexResponse) => orgs.find((org) => org.slug === params.companyId)

	// Cached data avoids flashing during token refresh, but may predate a just-created organisation.
	const cached = queryClient.getQueryData(organisationIndexQueryOptions().queryKey)
	let match = cached ? findMatch(cached) : undefined

	if (!match) {
		try {
			match = findMatch(await queryClient.fetchQuery({ ...organisationIndexQueryOptions(), staleTime: 0 }))
		} catch (error) {
			if (error instanceof AxiosError && error.response?.status === 403) {
				throw redirect({ to: '/company' })
			}
			throw error
		}
	}

	if (!match) {
		throw redirect({ to: '/company' })
	}

	return { jobillaOrgId: match.id, workosOrgId: match.workosId, isDemo: match.isDemo }
}
